import React from "react";
import { Text, View, ScrollView, Image } from "react-native";
import { FormattedMessage } from "react-intl";
import styles from "./styles";
import GoBackButton from "../../components/GoBackButton";
import HeaderTabs from "../../components/HeaderTabs";

const DepositBankAccount = () => {
  return (
    <>
      <HeaderTabs
        title={
          <FormattedMessage id="depositBankAccount.headerTabsDepositoBancario" />
        }
        subtitle={
          <FormattedMessage id="depositBankAccount.headerTabsSubDeposito" />
        }
      />
      <ScrollView>
        <View style={styles.containerCards}>
          <View style={styles.card}>
            <View style={styles.row}>
              <View style={styles.column}>
                <Text style={styles.lblInfo}>
                  <FormattedMessage id="depositBankAccount.headerBanco" />
                </Text>
                <Text>
                  <FormattedMessage id="depositBankAccount.txtNomeBanco" />
                </Text>
              </View>
              <View>
                <Image
                  style={styles.bankIcon}
                  source={require("../../../assets/bank.png")}
                />
              </View>
            </View>
            <Text style={styles.lblInfo}>
              <FormattedMessage id="depositBankAccount.headerNome" />
            </Text>
            <Text>
              <FormattedMessage id="depositBankAccount.textNomeEmpresa" />
            </Text>
            <Text style={styles.lblInfo}>
              <FormattedMessage id="depositBankAccount.headerSwift" />
            </Text>
            <Text>
              <FormattedMessage id="depositBankAccount.txtBeneficiaryCustomer" />
            </Text>
            <Text>
              <FormattedMessage id="depositBankAccount.txtSwiftCode" />
            </Text>
            <Text style={styles.lblInfo}>
              <FormattedMessage id="depositBankAccount.headerIbanBr" />
            </Text>
            <Text>
              <FormattedMessage id="depositBankAccount.txtIbanBr" />
            </Text>
            <Text style={styles.lblInfo}>
              <FormattedMessage id="depositBankAccount.headerObservacao" />
            </Text>
            <Text>
              <FormattedMessage id="depositBankAccount.txtObservacao" />
            </Text>
            <Text style={styles.lblInfo}>
              <FormattedMessage id="depositBankAccount.emailAddress" />
            </Text>
          </View>
          <GoBackButton />
        </View>
      </ScrollView>
    </>
  );
};

export default DepositBankAccount;
